import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Home } from 'lucide-react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import { useAIFormCheckVisibility } from '../hooks/useAIFormCheckVisibility';

/** Shown to public visitors / students who open an old AI Technique Review link while the feature is hidden. */
export const FeatureUnavailable = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    meta.setAttribute('data-feature-unavailable', '1');
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col" data-testid="feature-unavailable-page">
      <PublicHeader />
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-lg w-full text-center rounded-2xl border-2 border-[#E9D5FF] bg-white p-8 md:p-10 shadow-sm">
          <div className="mx-auto w-14 h-14 rounded-full bg-[#F3E8FF] flex items-center justify-center text-[#7E22CE]"><Clock size={26} /></div>
          <h1 className="text-2xl md:text-3xl font-black tracking-tight mt-5" data-testid="feature-unavailable-title">AI Technique Review is temporarily unavailable.</h1>
          <p className="text-slate-600 mt-2" data-testid="feature-unavailable-message">Please check back later.</p>
          <Link to="/" className="mt-6 inline-flex items-center gap-2 h-11 px-6 rounded-md bg-[#7E22CE] hover:bg-[#6B21A8] text-white font-black uppercase tracking-widest text-xs" data-testid="feature-unavailable-home-btn">
            <Home size={14} /> Back to Home
          </Link>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
};

/** Route wrapper: renders the page for staff (or when the owner reopens the feature), the unavailable notice for everyone else. */
export const AIFormCheckGate = ({ children }) => {
  const { loaded, visible } = useAIFormCheckVisibility();
  if (!loaded) return <div className="min-h-screen bg-[#FAFAFA]" data-testid="feature-gate-loading" />;
  return visible ? children : <FeatureUnavailable />;
};

export default FeatureUnavailable;
